import styled from "styled-components";

export const FormResponseStyle = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background-color: #ebf2ff;
  height: 100vh;
  .content {
    margin: 0 15px;
    background-color: #fff;
    max-width: 600px;
    margin-top: 15px;
    padding: 25px;
    border-radius: 10px;
    border-top: 10px solid #0d6efd;
    h2 {
      font-size: 30px;
      line-height: 42px;
      margin-bottom: 20px;
      @media (max-width: 768px) {
        font-size: 20px;
      }
    }
    a {
      color: #0d6efd;
    }
  }
  .another-btn {
    border: none;
    background-color: transparent;
    font-size: 16px;
    color: #0d6efd;
    text-decoration: underline;
    cursor: pointer;
  }
`;
